module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/link_icon/link_scene-1dcace2239e6a3c4535e7abe37eb04b5.svg&quot;;"